import eventBus from '@researchmetrics/event-bus'

const EventTitles = {
  'AppWrapper.ToolbarButtonTap': 'AppWrapper.ToolbarButtonTap',
  toolbarBackButtonShow: 'toolbar-back-button-show',
  toolbarBackButtonHide: 'toolbar-back-button-hide',
  toolbarTitleUpdate: 'toolbar-title-update',
  surveyOpen: 'app-wrapper-open-survey',
  contentLoad: 'app-wrapper-load-content',
  setModalEvent: 'app-wrapper-set-modal',
  setBackBtnEvent: 'app-back-button',
  goBackEvent: 'app-go-back',
  loadingShow: 'loading-show',
  loadingHide: 'loading-hide',
  menuBadgeUpdate: 'menu-badge-update',
  callbackRegistryDelegate: 'callback-registry-delegate',
  callbackRegistryResolve: 'callback-registry-resolve'
}

let loadingCounter = 0

const Loading = {
  show: function() {
    if (loadingCounter < 0) {
      loadingCounter = 0
    }
    loadingCounter++
    eventBus.publish(EventTitles.loadingShow, '')
  },
  hide: function(forced) {
    if (forced) {
      loadingCounter = 0
    } else {
      loadingCounter--
    }
    if (loadingCounter <= 0) {
      eventBus.publish(EventTitles.loadingHide, '')
    }
  }
}

const Toolbar = {
  buttons: {
    back: {
      id: 'rm-toolbar-back',
      name: 'Back'
    },
    close: {
      id: 'rm-toolbar-close',
      name: 'Close'
    }
  },
  show: function() {},
  hide: function() {},
  addItems: function() {},
  removeItems: function() {},
  showBackButton: function() {
    eventBus.publish(EventTitles.toolbarBackButtonShow, '')
  },
  hideBackButton: function() {
    eventBus.publish(EventTitles.toolbarBackButtonHide, '')
  },
  showCloseButton: function() {},
  hideCloseButton: function() {},
  setTitle: function(titleText) {
    eventBus.publish(EventTitles.toolbarTitleUpdate, titleText)
  },
  setTitleBadge: function() {}
}

const Menu = {
  setBadge: function(badgeData) {
    eventBus.publish(EventTitles.menuBadgeUpdate, badgeData)
  }
}

const Wrapper = {
  loadURL: function(params) {
    eventBus.publish(EventTitles.contentLoad, params)
  },
  openSurvey: function(surveyInstanceID) {
    eventBus.publish(EventTitles.surveyOpen, {
      surveyInstanceID: surveyInstanceID
    })
  },
  setActiveItem: function() {}
}
/*
const Event = {
  toolbarButtonTap: function() {}
}
*/
export { EventTitles }
export { Toolbar }
export { Loading }
export { Wrapper }
export { Menu }

export default {
  Loading: Loading,
  EventTitles: EventTitles,
  Toolbar: Toolbar,
  Wrapper: Wrapper,
  Menu: Menu
}
